import React from "react";
import {
  Grid,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider,
  Stack,
} from "@mui/material";
import PlayCircleRoundedIcon from "@mui/icons-material/PlayCircleRounded";
import oneImage from "../../../assets/Images/01.png";
import everydayLife from "../../../assets/Images/everydayLife.png";
import "../../../App.css";
import { isMobile } from "react-device-detect";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import { Link } from "react-router-dom";

const EveryDayLife = () => {
  return (
    <div className="mt-16 pt-16 pb-16">
      <Grid container spacing={6}>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          style={
            isMobile
              ? {
                  width: "45%",
                  borderRadius: "10px",
                  marginLeft: "20px",
                }
              : {
                  width: "45%",
                  borderRadius: "10px",
                  paddingLeft: "8%",
                  paddingRight: "5%",
                }
          }
        >
          <img
            src={everydayLife}
            style={
              isMobile
                ? { width: "350px", height: "300px" }
                : { width: "640px", height: "360px" }
            }
          />
        </Grid>
        <Grid
          item
          style={
            isMobile
              ? {
                  width: "100%",
                  marginLeft: "20px",
                }
              : {
                  width: "45%",
                }
          }
        >
          <>
            <Typography
              style={{
                fontWeight: "600",
                fontSize: "32px",
                lineHeight: "24px",
                color: "#222222",
              }}
            >
              Everyday life made easier!
            </Typography>

            <Stack className="mt-16 mb-16">
              <Stack
                direction="row"
                className="mt-10 mb-10"
                spacing={2}
                alignItems="center"
              >
                <CheckCircleSharpIcon
                  fontSize="large"
                  style={{ color: "#EEEBEF" }}
                />
                <Typography
                  style={{
                    fontSize: "20px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    color: "#737373",
                  }}
                >
                  Choose your Tasker by reviews, skills, and price
                </Typography>
              </Stack>
              <Stack
                direction="row"
                className="mt-10 mb-10"
                spacing={2}
                alignItems="center"
              >
                <CheckCircleSharpIcon
                  fontSize="large"
                  style={{ color: "#EEEBEF" }}
                />
                <Typography
                  style={{
                    fontSize: "20px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    color: "#737373",
                  }}
                >
                  Schedule when it works for you — as early as today
                </Typography>
              </Stack>
              <Stack
                direction="row"
                className="mt-10 mb-10"
                spacing={2}
                alignItems="center"
              >
                <CheckCircleSharpIcon
                  fontSize="large"
                  style={{ color: "#EEEBEF" }}
                />
                <Typography
                  style={{
                    fontSize: "20px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    color: "#737373",
                  }}
                >
                  Chat, pay, tip, and review all through one platform
                </Typography>
              </Stack>
            </Stack>

            <Link to="/create-request">
              <Button
                variant="contained"
                className="primary-button"
                size="small"
                style={{
                  textTransform: "capitalize",
                  padding: "16px 24px",
                  borderRadius: "6px",
                  fontWeight: "500",
                  fontSize: "16px",
                  lineHeight: "24px",
                }}
              >
                Post Request
              </Button>
            </Link>
          </>
        </Grid>
      </Grid>
    </div>
  );
};

export default EveryDayLife;
